import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  utility: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '2px',
    padding: '32px 0',
    borderTop: "1px solid ".concat(palette.shades[400]),
    '& .MuiSvgIcon-root': {
      backgroundColor: palette.shades[100],
      boxShadow: palette.shadows.light
    },
    '&:first-child': {
      paddingTop: '0',
      marginTop: '32px',
      borderTop: 'none'
    },
    '&:last-child': {
      paddingBottom: '0'
    }
  },
  utilityName: {
    flexGrow: 1,
    padding: '0 20px',
    overflow: 'hidden',
    '& .MuiTypography-h5': {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  billing: {
    display: 'flex',
    alignItems: 'center'
  }
});
export default useStyles;